import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { Form, Field } from 'formik';
import { DropdownWithValidation, LegacyInputTextComponent } from '../../../components/prime-formik';
import Debug from '../../../components/Debug';
import { formikFormShape, intlShape } from '../../../components/prop-types';

const i18n = defineMessages({
  choose: { id: 'choose', defaultMessage: 'Choose' },
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
  save: { id: 'actions.save', defaultMessage: 'Save' },
  namePlaceHolder: { id: 'add.survey_project.name.placeholder', defaultMessage: 'Name - SuperSurvey' },
});

class NewSurveyProjectComponent extends Component {
  render() {
    const {
      formProps: { isSubmiting },
      onCancel,
      templates,
      intl: { formatMessage },
    } = this.props;

    return (
      <Panel header={<FormattedMessage id="page.super_survey.new" defaultMessage="Add SuperSurvey" />}>
        <Form>
          <div className="p-grid p-fluid">
            <div className="p-md-4 p-sm-6 p-xs-12">
              <FormattedMessage
                tagName="label"
                className="field-label"
                htmlFor="projectName"
                id="super_suvey.name"
                defaultMessage="SuperSurvey Name"
              />
              <Field
                id="projectName"
                name="projectName"
                placeholder={formatMessage(i18n.namePlaceHolder)}
                component={LegacyInputTextComponent}
              />
            </div>
          </div>
          <div className="p-grid p-fluid">
            <div className="p-md-4 p-sm-6 p-xs-12">
              <FormattedMessage
                className="field-label"
                htmlFor="surveyTemplateId"
                tagName="label"
                id="super_survey.template"
                defaultMessage="Survey Template"
              />
              <Field
                id="surveyTemplateId"
                inputId="surveyTemplateId"
                name="surveyTemplateId"
                component={DropdownWithValidation}
                options={templates}
                placeholder={`- ${formatMessage(i18n.choose)} -`}
              />
            </div>
          </div>
          <div className="p-grid">
            <div className="p-col-12">
              <Button
                type="submit"
                icon={isSubmiting ? 'pi pi-spin pi-spinner' : ''}
                label={formatMessage(i18n.save)}
                disabled={isSubmiting}
              />
              <Button
                type="button"
                className="p-button-secondary"
                label={formatMessage(i18n.cancel)}
                onClick={onCancel}
              />
            </div>
          </div>
          <Debug />
        </Form>
      </Panel>
    );
  }
}

NewSurveyProjectComponent.propTypes = {
  formProps: formikFormShape.isRequired,
  onCancel: PropTypes.func.isRequired,
  templates: PropTypes.arrayOf(PropTypes.any).isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(NewSurveyProjectComponent);
